import { Component, type ReactNode } from 'react'

interface State {
  hasError: boolean
}

// MapErrorBoundary keeps a Google Maps failure (a key refused for the page's
// origin, a blocked script) inside the map: the form around it stays usable
// instead of the whole page crashing.
export class MapErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) return <div data-testid="map-unavailable" />
    return this.props.children
  }
}
